// blocks
import Categories from "./Blocks/Categories";
import Menu from "./Blocks/Menu";
import Slider from "./Blocks/Slider";
import UserMenu from "./Blocks/UserMenu";
import LanguageSwitcher from "./Blocks/LanguageSwitcher";

const cmsInit = {
	reducers: {},
	routes: [],
	blocks: {
		"cms-categories": {
			component: Categories,
			setting: {}
		},
		"cms-menu": {
			component: Menu,
			setting: {}
		},
		"cms-slider": {
			component: Slider,
			setting: {
				slides: {form: "slides"},
				indicators: {form: "checkbox"},
				controls: {form: "checkbox"},
				fade: {form: "checkbox"},
			}
		},
		"user-menu": {
			component: UserMenu,
			setting: {
				title: {form: "text"}
			}
		},
		"language-switcher": {
			component: LanguageSwitcher,
			setting: {}
		},
	},
	i18n: {
		en: {},
		ar: {
			"Login / Register": "دخول/تسجيل",
			Remove: "إزالة",
			Profile: "الملف الشخصي",
			"Track Your Orders": " متابعة الطلبات",
			"Your Addresses": " إدارة العناوين",
			"Favorites": "المفضلة",
			"Compare Products": "مقارنة المنتجات",
			"Sign out": " تسجيل الخروج"
		}
	},
};

export default cmsInit;

